import React from "react";
import {
  InlineTypeahead,
  InlineTypeaheadProps,
} from "~/components/inline-typeahead";
import { GroupedFolder } from "~/gql/types2";

const format = (item: GroupedFolder): React.ReactNode => item.name;

export type InlineGroupedFolderPickerProps = {
  value: GroupedFolder | null;
  name: string;
  onChange: (value: GroupedFolder | null) => void;
  onBlur?: React.FocusEventHandler<any>;
  required?: boolean;
  submitError?: string;
  groupedFolders: GroupedFolder[];
};

export const InlineGroupedFolderPicker: React.FC<
  InlineGroupedFolderPickerProps
> = (props) => {
  const { groupedFolders, ...rest } = props;

  const getData = async (searchText: string) => {
    if (!searchText) {
      return groupedFolders;
    }

    return groupedFolders.filter((t) =>
      t.name.toLowerCase().includes(searchText.toLowerCase())
    );
  };

  const args = {
    ...rest,
    getData,
    format,
  } as InlineTypeaheadProps<GroupedFolder>;

  return <InlineTypeahead {...args} />;
};
